<header class="topbar-v3">

  <div class="logo">
    <img src="assets/images/annuity_logo.png" alt="Beacon Nexus"/>
  </div>

  <!-- <div class="logo">
    <img src="assets/images/beacon_logo.png" alt="Beacon Nexus"/>
  </div> -->

  <span class="tb-spacer"></span>

  <!-- <button class="chip-btn case-chip" type="button" [class.loaded]="caseLoaded()"
          [title]="caseChipTitle()" (click)="onCaseChipClick($event)">
    @if (caseLoaded()) {
      <span class="cp-dot" aria-hidden="true"></span>
      <span class="cp-name">{{ caseName() }}</span>
      @if (caseSummary()) {
        <span class="cp-crit mono">{{ caseSummary() }}</span>
      }
    } @else {
      <span class="cp-empty">No case</span>
    }
    <span class="caret">▾</span>
  </button> -->

  <!-- <span class="util-divider" aria-hidden="true"></span> -->

  <!-- <button class="util-ico" type="button" title="Inbox" (click)="onInboxIconClick($event)">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/>
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
    </svg>
    @if (inboxCount() > 0) {
      <span class="badge">{{ inboxCount() }}</span>
    }
  </button> -->

  <button class="util-ico" type="button" title="Basket" (click)="onBasketIconClick($event)">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <circle cx="9" cy="21" r="1"/>
      <circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
    @if (basketCount() > 0) {
      <span class="badge amber">{{ basketCount() }}</span>
    }
  </button>

  <span class="util-divider" aria-hidden="true"></span>

  <!-- <button class="util-ico" type="button" title="Notifications" (click)="onBellClick($event)">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
    @if (bellCount() > 0) {
      <span class="badge">{{ bellCount() }}</span>
    }
  </button> -->

  <div class="av-wrap" (click)="$event.stopPropagation()">
    <button class="avatar" type="button" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen()" [title]="displayName() || 'Account'">
      {{ userInitials() }}
    </button>
    @if (menuOpen()) {
      <div class="av-menu" role="menu">
        <div class="av-menu-head">
          <div class="av-menu-name">{{ displayName() || 'Account' }}</div>
          <div class="av-menu-co">{{ session.companyName() || '—' }}</div>
        </div>
        <!-- @if (devUserLoaded()) {
          <button class="av-menu-item av-menu-item--dev" type="button" role="menuitem" (click)="exitDevUser()">
            <span class="av-dev-pip" aria-hidden="true"></span>
            Exit user → full preview
            <span class="av-menu-meta">restores all menu / config</span>
          </button>
          <div class="av-menu-divider"></div>
        } 
        <button class="av-menu-item av-menu-item--dev" type="button" role="menuitem" (click)="onToggleNewShell()">
          <span class="av-dev-pip" aria-hidden="true"></span>
          Use the old shell
          <span class="av-menu-meta">Phase 2 preview</span>
        </button>
        <div class="av-menu-divider"></div>-->
        <button class="av-menu-item" type="button" role="menuitem" (click)="navigate('/account/settings')">
          Account Settings
        </button>
        <button class="av-menu-item" type="button" role="menuitem" (click)="navigate('/account/security')">
          Security
        </button>
        <div class="av-menu-divider"></div>
        <button class="av-menu-item av-menu-item--muted" type="button" role="menuitem" (click)="signOut()">
          Sign out
        </button>
      </div>
    }
  </div>

</header>
